import { Trans } from 'react-i18next';
import styles from './SurpriseTripGift.module.scss';
import GiftTypeSelector from '../../gifts/giftTypeSelector/GiftTypeSelector';

const SurpriseTripGift = () => (
    <section className={styles.surpriseTripContainer}>
        <h2 className={styles.sectionTitle}>
            <Trans i18nKey="surpriseTripGiftTitle">
                Gift a surprise <span className={styles.colouredSpan}>trip</span>
            </Trans>
        </h2>
        <GiftTypeSelector />
    </section>
);

export default SurpriseTripGift;
